import { render, staticRenderFns } from "./poptip.vue?vue&type=template&id=f183b230&scoped=true"
import script from "./poptip.vue?vue&type=script&lang=js"
export * from "./poptip.vue?vue&type=script&lang=js"
import style0 from "./poptip.vue?vue&type=style&index=0&id=f183b230&prod&scoped=true&lang=css"
import style1 from "./poptip.vue?vue&type=style&index=1&id=f183b230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f183b230",
  null
  
)

export default component.exports